import { Component, ChangeDetectionStrategy } from "@angular/core";
import { FieldType } from "@ngx-formly/core";

@Component({
    selector: "formly-field-imask",
    template: `
        <mat-form-field class="w-full v2-form-field" [formGroup]="form">
            <mat-label *ngIf="to.label">{{ to.label }}</mat-label>
            <span class="text-hint" matPrefix *ngIf="to.prefix">{{ to.prefix }}</span>
            <input
                [required]="to.required"
                type="text"
                matInput
                [imask]="imaskConfig"
                [unmask]="true"
                [placeholder]="to.placeholder"
                autocomplete="tel"
                [formControl]="formControl"
            />
            <span class="text-hint" matSuffix *ngIf="to.suffix">{{ to.suffix }}</span>
            <mat-hint *ngIf="to.description">{{ to.description }}</mat-hint>
            <mat-error *ngIf="showError">
                <formly-validation-message [field]="field"></formly-validation-message>
            </mat-error>
        </mat-form-field>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyFieldIMask extends FieldType {
    get imaskConfig() {
        const maskOptions = this.to.maskOptions;
        if (maskOptions && maskOptions.mask === "Number") {
            return {
                ...maskOptions,
                mask: Number,
            };
        }

        return maskOptions;
    }
}
